<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						基本信息
					</div>
					<div style="padding: 30px;" class="form">
						<el-form :model="dataForm" :rules="rules" ref="ruleForm" label-width="140px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="代理人ID" >
								<el-link type="primary" @click="toCopy(dataForm.agent_id)">{{dataForm.agent_id}} 点击复制</el-link>
							</el-form-item>
							<el-form-item label="代理码" >
								<el-link type="primary" @click="toCopy(dataForm.agent_code)">{{dataForm.agent_code}} 点击复制</el-link>
							</el-form-item>
							<el-form-item label="代理人备注">
								<el-input type="text" placeholder="请输入代理人备注" size="small" v-model="dataForm.one"
									style="width: 300px;"></el-input>
								<div style="font-size: 13px;">(默认为代理人ID)</div>
							</el-form-item>				
							<el-form-item label="所属软件" prop="software_id">
								<el-select v-model="dataForm.software_id" clearable placeholder="请选择所属软件"
									style="width: 300px;margin-right: 10px;" size="small">
									<el-option v-for="(item,index) in software_list" :key="index" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="是否限制代理时间">
								<el-radio-group v-model="dataForm.limit_endtime">
									<el-radio :label="1">限制</el-radio>
									<el-radio :label="0">不限制</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="代理权限到期时间" prop="endtime" v-if="dataForm.limit_endtime==1">
								<el-date-picker size="small" v-model="dataForm.endtime" type="datetime"
									placeholder="选择到期时间" style="width: 300px;">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="是否可以开子代理" >
								<el-radio-group v-model="dataForm.could_child">
									<el-radio :label="1">可以</el-radio>
									<el-radio :label="0">不可以</el-radio>
								</el-radio-group>
							</el-form-item>
							
							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">修改</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				
				<div class="centext-box" style="margin-top: 10px;">
					<div class="header">
						子代理列表
					</div>
					<div style="padding:0px;" class="form">
						 <el-table
						      :data="child_agent"
							  style="width: 100%;padding:0px 0px;background-color: rgb(66, 75, 79);color: #fff;"
							  :header-cell-style="{background:'rgb(66, 75, 79)',color:'#fff'}"
							  :cell-style="{background:'rgb(66, 75, 79)',color:'#fff'}" 
							  :row-style="{border_color:'rgb(66, 75, 79)'}">
						      <el-table-column
						        prop="id"
						        label="代理人ID"
								align="center">
						      </el-table-column>
						    </el-table>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						代理价格
					</div>
					<div style="padding: 20px;" click="form" >
						<div class="t-header">
							<div class="t-item">
								卡密类型
							</div>
							<div class="t-item">
								是否开放出售
							</div>
							<div class="t-item">
								价格
							</div>
						</div>
						<div class="t-body" v-for="(item,index) in card_type_list"
							v-if="[8,10].indexOf(parseInt(item.id))==-1" :key="index">
							<div class="t-item">
								{{item.name}}卡
							</div>
							<div class="t-item">
								<el-switch :value ="salesquence.indexOf(parseInt(item.id))!=-1 ? true : false" @change="switchChange($event,item.id)">
								</el-switch>
							</div>
							<div class="t-item">
								<el-input type="number" placeholder="请输入" size="small"
									v-model="price[item.id]" style="width: 70px;"></el-input>
							</div>
						</div>
						<div style="padding: 20px;display: flex;justify-content: flex-end;">
							<el-button type="primary" size="small" @click="sell_confirm()">修改</el-button>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				dataForm: {
					id:'',
					agent_id:'',
					one:'',
					software:'',
					software_id:'',
					could_child:0,
					limit_endtime:0,
					endtime:'',
				},
				rules: {
					software_id: [{
						required: true,
						message: '请选择代理软件',
						trigger: 'change'
					}],
					agent_code: [{
						required: true,
						message: '请输入代理码',
						trigger: 'blur'
					}],
					endtime: [{
						required: true,
						message: '请选择代理到期时间',
						trigger: 'change'
					}],
				},
				type_config: {},
				software_list: [],
				card_type_list: [],
				price:[],
				salesquence:[],
				child_agent:[]
			}
		},
		props:{
			agent_software_id:Number
		},
		created() {
			this.resetForm()
			this.getData()
		},
		methods: {
			toCopy(value){
				console.log(value)
				this.$copyText(value.toString()).then((e) => {
					this.$message.success('复制成功')
					console.log(e)
				}, (e) => {
					console.log(e)
				})
			},
			switchChange(e,v){
				console.log(v)
				if(!e){
					let index = this.salesquence.findIndex(item=>item==v)
					if(index>-1){
						this.salesquence.splice(index,1)
					}
				}else{
					this.salesquence.push(parseInt(v))
				}
				console.log(this.salesquence)
			},
			sell_confirm(){
				var data = {
					id:this.dataForm.id,
					salesquence:JSON.stringify(this.salesquence),
					price:JSON.stringify( this.price ),
				}
				//console.log( data );return false;
				this.$H.post('verify_center/v1_0_1.Agent/UpdateSell',data).then(res => {
					if(res.data){
						this.$message.success('处理成功')
						this.getData()
					}
					
				});
			},
			getData() {
				this.$H.post('verify_center/v1_0_1.Software/list',{}).then(res => {
					if(res.data){
						this.software_list = res.data.list;
					}
				});
				this.$H.post('verify_center/v1_0_1.Card/TypeList').then(res => {
					if(res.data){
						this.card_type_list = res.data.list;
					}
				});
				this.$H.post('verify_center/v1_0_1.Agent/Info',{
					agent_software_id:this.agent_software_id
				}).then(res => {
					if(res.data){
						console.log(res.data)
						this.dataForm.id = res.data.id
						this.dataForm.agent_id = res.data.agent_id
						this.dataForm.software_id= res.data.software_id
						this.dataForm.agent_code= res.data.agent_code
						this.dataForm.one= res.data.one
						this.dataForm.endtime = this.formatTime(res.data.endtime)
						this.dataForm.could_child = res.data.could_child
						this.price = JSON.parse(res.data.price)
						this.child_agent = res.data.child_agent.map(data=>{
							let item= {}
							item.id = data
							return item
						})
						this.salesquence =res.data.salesquence===''?[]: JSON.parse(res.data.salesquence).map(item=>parseInt(item));
						console.log(this.salesquence)
						if(res.data.endtime) {
							this.dataForm.limit_endtime = 1;
						} 
					}
				});
			},
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			},
			submitForm() {
				var data = {
					id:this.dataForm.id,
					one:this.dataForm.one,
					software_id:this.dataForm.software_id,
					could_child:this.dataForm.could_child,
					endtime:this.dataForm.endtime,
				}
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('/verify_center/v1_0_1.Agent/Edit', data).then(res => {
							if(res.data){
								this.$message.success('修改成功')
								this.$emit('back')
							}
						
						}).catch(err => {
							console.log(err)
							this.$emit('back')
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.t-header {
		padding: 8px 13px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: 700;
		display: flex;
	}
	
	.t-body {
		padding: 8px 13px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: normal;
		display: flex;
	}
	
	.t-item {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>